"use strict";
/* eslint compat/compat:"off" */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGQLKeeperInterceptors = exports.addKeeperInterceptors = void 0;
var global_1 = require("../global");
var util_now_1 = require("./util.now");
function addKeeperInterceptors(axiosInstance, extra) {
    if (extra === void 0) { extra = {}; }
    // Добавляем мета данные
    addKeeperMeta(axiosInstance);
    // Скидываем метрики
    axiosInstance.interceptors.response.use(
    // 2XX OK
    function (resp) {
        global_1.coreKeeperAPI(resp, __assign(__assign({}, extra), { duration: getKeeperDuration(resp) }));
        return resp;
    }, 
    // Error handling
    function (err) {
        global_1.coreKeeperAPI(err.request, __assign(__assign({}, extra), { duration: getKeeperDuration(err) }));
        return Promise.reject(err);
    });
}
exports.addKeeperInterceptors = addKeeperInterceptors;
function addGQLKeeperInterceptors(axiosInstance, gqlResponseToStatus, extra) {
    if (extra === void 0) { extra = {}; }
    // Добавляем мета данные
    addKeeperMeta(axiosInstance);
    // Скидываем метрики
    axiosInstance.interceptors.response.use(
    // 2XX OK
    function (resp) {
        var _a;
        if (!((_a = resp.config.url) === null || _a === void 0 ? void 0 : _a.includes('graphql'))) {
            return resp;
        }
        var apiStatus = gqlResponseToStatus(resp);
        if (apiStatus && resp.status !== apiStatus) {
            // Удалим статус, так как сами его сматчили из gql ответа
            delete resp.status;
        }
        global_1.coreKeeperAPI(resp, __assign(__assign({}, extra), { url: getKeeperGQLUrl(resp), duration: getKeeperDuration(resp), apiStatus: apiStatus }));
        return resp;
    }, 
    // Error handling
    function (err) {
        var _a;
        if (!((_a = err.config.url) === null || _a === void 0 ? void 0 : _a.includes('graphql'))) {
            return Promise.reject(err);
        }
        // Если ошибка, оставим статус, который есть. Так как нет GQL ответа
        global_1.coreKeeperAPI(err.request, __assign(__assign({}, extra), { url: getKeeperGQLUrl(err), duration: getKeeperDuration(err) }));
        return Promise.reject(err);
    });
}
exports.addGQLKeeperInterceptors = addGQLKeeperInterceptors;
function addKeeperMeta(axiosInstance) {
    axiosInstance.interceptors.request.use(function (config) {
        config.keeper = {
            start: util_now_1.now(),
        };
        return config;
    });
}
function getKeeperDuration(val) {
    var start = getKeeperStart(val);
    return start ? util_now_1.now() - start : 0;
}
function getKeeperGQLUrl(val) {
    var operationName = getOperationName(val);
    return (val === null || val === void 0 ? void 0 : val.config.url) + "/" + operationName;
}
function getKeeperStart(val) {
    var _a;
    var cfg = undefined;
    if (val && 'response' in val) {
        val = val.response;
    }
    if (val && 'config' in val) {
        cfg = val.config;
    }
    return (cfg && 'keeper' in cfg && ((_a = cfg.keeper) === null || _a === void 0 ? void 0 : _a.start)) || 0;
}
function getOperationName(val) {
    var cfg = undefined;
    if (val && 'response' in val) {
        val = val.response;
    }
    if (val && 'config' in val) {
        cfg = val.config;
    }
    return (cfg && 'operationName' in cfg && cfg.operationName) || 'unk';
}
//# sourceMappingURL=axios.js.map